module.exports = __webpack_public_path__ + "img/contract.9465dcd5.png";